import * as o from "react";
import t from "../lib/IconBase.es.js";
import s from "../defs/ClockCounterClockwise.es.js";
const e = o.forwardRef((c, r) => /* @__PURE__ */ o.createElement(t, { ref: r, ...c, weights: s }));
e.displayName = "ClockCounterClockwiseIcon";
const a = e;
export {
  a as ClockCounterClockwise,
  e as ClockCounterClockwiseIcon
};
